import {
  FinalizarAtendimentoIndividualInput,
  MedicamentoInterromperInput,
  MedicoesInput,
} from 'graphql/types.generated'
import { parseNumber } from 'util/number'

import { MedicamentoInterromperFormModel } from '../detail/components/modals/medicamentos/InterromperTratamentoModal'
import { MedicaoAnteriorFormModel } from '../detail/components/modals/medicoes/MedicaoAnteriorForm'
import { convertAvaliacaoFormToInput } from '../detail/soap/avaliacao/converter'
import { convertDesfechoFormToInput } from '../detail/soap/desfecho'
import { convertObjetivoFormToInput } from '../detail/soap/objetivo'
import { convertPlanoFormToInput } from '../detail/soap/plano/converter'
import { convertSubjetivoFormToInput } from '../detail/soap/subjetivo'
import { SoapState } from './model'

export const converAtendimentoIndividualModelToInput = (
  atendimentoId: ID,
  cidadaoId: ID,
  values: SoapState
): FinalizarAtendimentoIndividualInput => ({
  id: atendimentoId,
  finalizadoEm: new Date().getTime(),
  subjetivo: convertSubjetivoFormToInput(values.subjetivo),
  objetivo: convertObjetivoFormToInput(values.objetivo),
  avaliacao: convertAvaliacaoFormToInput(values.avaliacao),
  plano: convertPlanoFormToInput(values.plano),
  desfecho: convertDesfechoFormToInput(cidadaoId, values.desfecho),
  medicoesAnteriores: values.medicoesAnteriores?.map(convertMedicaoAnterior),
  medicamentoInterromper: values.medicamentosInterromper?.map(convertMedicamentoInterrupcao),
})

export const convertMedicaoAnterior = (medicao: MedicaoAnteriorFormModel): MedicoesInput => ({
  dataMedicao: medicao.data,
  altura: parseNumber(medicao.altura),
  perimetroCefalico: parseNumber(medicao.perimetroCefalico),
  peso: parseNumber(medicao.peso),
})

export const convertMedicamentoInterrupcao = (
  medicamento: MedicamentoInterromperFormModel
): MedicamentoInterromperInput => ({
  id: medicamento.id,
  justificativa: medicamento.justificativa,
})
